export const themes_data = {
    dark: {
        title: "Dark Theme",
        bgc: "#123",
        hover: "#374757",
        border: "#25323f",
        textColor: "#fff",
    },
    white: {
        title: "White Theme",
        bgc: "#ffffff",
        hover: "#f0f0f0",
        border: "#dcdcdc",
        textColor: "#000",
    }
}